// src/propertyManagement/pages/AddVendorPage.jsx
import React, { useState } from 'react';
import { useNavigate }          from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import ArrowBackIcon            from '@mui/icons-material/ArrowBack';
import EmailIcon                from '@mui/icons-material/Email';
import PhoneIcon                from '@mui/icons-material/Phone';
import HomeIcon                 from '@mui/icons-material/Home';
import BusinessIcon             from '@mui/icons-material/Business';
import ReceiptIcon              from '@mui/icons-material/Receipt';
import ShieldIcon               from '@mui/icons-material/Shield';

export default function AddVendorPage() {
  const navigate = useNavigate();

  // — form state —
  const [firstName, setFirstName]     = useState('');
  const [lastName, setLastName]       = useState('');
  const [companyName, setCompanyName] = useState('');
  const [isCompany, setIsCompany]     = useState(false);
  const [category, setCategory]       = useState('Uncategorized');
  const [expenseAccount, setExpenseAccount] = useState('');
  const [accountNumber, setAccountNumber]   = useState('');
  const [primaryEmail, setPrimaryEmail]     = useState('');
  const [alternateEmail, setAlternateEmail] = useState('');
  const [phone, setPhone]                   = useState('');
  const [mobile, setMobile]                 = useState('');
  const [fax, setFax]                       = useState('');
  const [otherPhone, setOtherPhone]         = useState('');
  const [street1, setStreet1]               = useState('');
  const [street2, setStreet2]               = useState('');
  const [street3, setStreet3]               = useState('');
  const [city, setCity]                     = useState('');
  const [state, setState]                   = useState('');
  const [zip, setZip]                       = useState('');
  const [country, setCountry]               = useState('United States');
  const [website, setWebsite]               = useState('');
  const [comments, setComments]             = useState('');
  // 1099
  const [taxIdType, setTaxIdType]   = useState('');
  const [taxpayerId, setTaxpayerId] = useState('');
  const [useDiffName, setUseDiffName]     = useState(false);
  const [useDiffAddress, setUseDiffAddress] = useState(false);
  // Insurance
  const [insProvider, setInsProvider]   = useState('');
  const [policyNumber, setPolicyNumber] = useState('');
  const [expDate, setExpDate]           = useState('');

  return (
    <Box sx={{ p:3, bgcolor:'#f5f6f8' }}>
      {/* — Header — */}
      <Box sx={{ display:'flex', alignItems:'center', gap:2, mb:3 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ textTransform:'none' }}
        >
          Back
        </Button>
        <Typography variant="h4">Add vendor</Typography>
      </Box>

      <Box component="form" sx={{ p:3, bgcolor:'#fff', borderRadius:1, boxShadow:1 }}>
        {/* — Name & Company — */}
        <Typography variant="subtitle2" gutterBottom>
          Name <span style={{ color:'#777' }}>(required)</span>
        </Typography>
        <Box sx={{ display:'flex', gap:2, mb:3 }}>
          <TextField
            fullWidth size="small" placeholder="First"
            value={firstName} onChange={e=>setFirstName(e.target.value)}
          />
          <TextField
            fullWidth size="small" placeholder="Last"
            value={lastName} onChange={e=>setLastName(e.target.value)}
          />
        </Box>

        <Typography variant="subtitle2" gutterBottom>
          Company name
        </Typography>
        <Box sx={{ display:'flex', alignItems:'center', gap:2, mb:3 }}>
          <TextField
            fullWidth size="small" placeholder="Company name"
            value={companyName} onChange={e=>setCompanyName(e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isCompany}
                onChange={e=>setIsCompany(e.target.checked)}
              />
            }
            label="Company"
          />
        </Box>

        {/* — Category / Account — */}
        <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:2, mb:3 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Category</InputLabel>
            <Select
              value={category}
              label="Category"
              onChange={e=>setCategory(e.target.value)}
            >
              <MenuItem value="Uncategorized">Uncategorized</MenuItem>
              <MenuItem value="Contractors - General">Contractors - General</MenuItem>
              <MenuItem value="Contractors - Trash">Contractors - Trash</MenuItem>
              <MenuItem value="Contractors - HVAC">Contractors - HVAC</MenuItem>
              {/* … */}
            </Select>
          </FormControl>
          <FormControl size="small" fullWidth>
            <InputLabel>Expense account</InputLabel>
            <Select
              value={expenseAccount}
              label="Expense account"
              onChange={e=>setExpenseAccount(e.target.value)}
            >
              <MenuItem value="">Please select</MenuItem>
              <MenuItem value="Repairs">Repairs</MenuItem>
              <MenuItem value="Maintenance">Maintenance</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth size="small" label="Account number"
            value={accountNumber}
            onChange={e=>setAccountNumber(e.target.value)}
          />
        </Box>

        <Divider sx={{ mb:3 }} />

        {/* — Contact Information — */}
        <Typography variant="subtitle2" gutterBottom>
          Contact information
        </Typography>
        <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:2, mb:3 }}>
          <TextField
            fullWidth size="small"
            placeholder="Primary email"
            InputProps={{
              startAdornment: <EmailIcon sx={{ mr:1, color:'#888' }} />
            }}
            value={primaryEmail}
            onChange={e=>setPrimaryEmail(e.target.value)}
          />
          <TextField
            fullWidth size="small"
            placeholder="Alternate email"
            InputProps={{
              startAdornment: <EmailIcon sx={{ mr:1, color:'#888' }} />
            }}
            value={alternateEmail}
            onChange={e=>setAlternateEmail(e.target.value)}
          />
        </Box>

        <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:2, mb:3 }}>
          <TextField
            fullWidth size="small"
            placeholder="Phone"
            InputProps={{
              startAdornment: <PhoneIcon sx={{ mr:1, color:'#888' }} />
            }}
            value={phone}
            onChange={e=>setPhone(e.target.value)}
          />
          <TextField
            fullWidth size="small"
            placeholder="Mobile"
            InputProps={{
              startAdornment: <PhoneIcon sx={{ mr:1, color:'#888' }} />
            }}
            value={mobile}
            onChange={e=>setMobile(e.target.value)}
          />
          <TextField
            fullWidth size="small"
            placeholder="Fax"
            InputProps={{
              startAdornment: <PhoneIcon sx={{ mr:1, color:'#888' }} />
            }}
            value={fax}
            onChange={e=>setFax(e.target.value)}
          />
          <TextField
            fullWidth size="small"
            placeholder="Other"
            InputProps={{
              startAdornment: <PhoneIcon sx={{ mr:1, color:'#888' }} />
            }}
            value={otherPhone}
            onChange={e=>setOtherPhone(e.target.value)}
          />
        </Box>

        {/* — Address — */}
        <Box sx={{ mb:3 }}>
          <TextField
            fullWidth size="small"
            placeholder="Street address 1"
            value={street1}
            onChange={e=>setStreet1(e.target.value)}
            sx={{ mb:1 }}
          />
          <TextField
            fullWidth size="small"
            placeholder="Street address 2"
            value={street2}
            onChange={e=>setStreet2(e.target.value)}
            sx={{ mb:1 }}
          />
          <TextField
            fullWidth size="small"
            placeholder="Street address 3"
            value={street3}
            onChange={e=>setStreet3(e.target.value)}
          />
          <Box sx={{ display:'flex', gap:2, mt:2 }}>
            <TextField
              fullWidth size="small" placeholder="City"
              value={city} onChange={e=>setCity(e.target.value)}
            />
            <FormControl fullWidth size="small">
              <InputLabel>State</InputLabel>
              <Select
                value={state}
                label="State"
                onChange={e=>setState(e.target.value)}
              >
                <MenuItem value="">Select…</MenuItem>
                <MenuItem value="TN">TN</MenuItem>
                <MenuItem value="CA">CA</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth size="small" placeholder="ZIP"
              value={zip} onChange={e=>setZip(e.target.value)}
            />
          </Box>
          <FormControl fullWidth size="small" sx={{ mt:2 }}>
            <InputLabel>Country</InputLabel>
            <Select
              value={country}
              label="Country"
              onChange={e=>setCountry(e.target.value)}
            >
              <MenuItem value="United States">United States</MenuItem>
              <MenuItem value="Canada">Canada</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <TextField
          fullWidth size="small" placeholder="Website (http://)"
          value={website}
          onChange={e=>setWebsite(e.target.value)}
          sx={{ mb:3 }}
        />

        <TextField
          fullWidth size="small" label="Comments"
          multiline rows={3}
          value={comments}
          onChange={e=>setComments(e.target.value)}
          sx={{ mb:3 }}
        />

        <Divider sx={{ mb:3 }} />

        {/* — 1099-NEC tax filing — */}
        <Box sx={{ mb:3 }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
            <ReceiptIcon color="action" />
            <Typography variant="subtitle1">1099-NEC tax filing information</Typography>
          </Box>
          <Box sx={{ display:'flex', gap:2, mb:2 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Tax identity type</InputLabel>
              <Select
                value={taxIdType}
                label="Tax identity type"
                onChange={e=>setTaxIdType(e.target.value)}
              >
                <MenuItem value="SSN">SSN</MenuItem>
                <MenuItem value="EIN">EIN</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth size="small" placeholder="Enter SSN or EIN"
              value={taxpayerId}
              onChange={e=>setTaxpayerId(e.target.value)}
            />
          </Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={useDiffName}
                onChange={e=>setUseDiffName(e.target.checked)}
              />
            }
            label="Use a different name"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={useDiffAddress}
                onChange={e=>setUseDiffAddress(e.target.checked)}
              />
            }
            label="Use a different address"
          />
        </Box>

        <Divider sx={{ mb:3 }} />

        {/* — Insurance — */}
        <Box sx={{ mb:3 }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
            <ShieldIcon color="action" />
            <Typography variant="subtitle1">Insurance</Typography>
          </Box>
          <TextField
            fullWidth size="small" label="Provider"
            value={insProvider}
            onChange={e=>setInsProvider(e.target.value)}
            sx={{ mb:2 }}
          />
          <TextField
            fullWidth size="small" label="Policy number"
            value={policyNumber}
            onChange={e=>setPolicyNumber(e.target.value)}
            sx={{ mb:2 }}
          />
          <TextField
            fullWidth size="small"
            label="Expiration date"
            type="date"
            InputLabelProps={{ shrink:true }}
            value={expDate}
            onChange={e=>setExpDate(e.target.value)}
          />
        </Box>

        {/* — Actions — */}
        <Box sx={{ display:'flex', gap:2, justifyContent:'flex-end', mt:4 }}>
          <Button
            variant="contained"
            onClick={() => {
              // TODO: submit logic
            }}
          >
            Create vendor
          </Button>
          <Button variant="text" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Box>
  );
}